<div class="modal-header">
  @if (isNewOrganization) {
    <h4 class="modal-title h5" translate>New Organization</h4>
  }
  @if (!isNewOrganization) {
    <h4 class="modal-title h5" translate>Edit Organization</h4>
  }
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form (ngSubmit)="onSave()" [formGroup]="organizationForm" autocomplete="off">
  <div style="position: absolute; top: -999px; left: -999px;display: none" >
    <input name="username" type="text"/>
    <input name="password" type="password"/>
  </div>
  <div class="modal-body">
    <div class="form-row">
      <!--DATASET & PARENT-->
      <div class="col-12 col-lg-6">
        <!--DATASET NAME-->
        <div class="form-group">
          <label for="name" translate>Dataset name</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input [ngClass]="{ 'is-invalid': f.name.errors }" class="form-control"
            formControlName="name"
            id="name"
            name="name"
            type="text">

            @if (f.name.errors) {
              <div class="invalid-feedback">
                @if (f.name.errors.required) {
                  <span translate>Dataset name required</span>
                }
                @if (f.name.errors.used) {
                  <span translate>The dataset name is already used!</span>
                }
                @if (f.name.errors.pattern) {
                  <span
                  translate>The name can only consist of latin letters, numbers, underscores.</span>
                }
              </div>
            }
            @if (f.name.value && f.name.value !== backupOrganizationName && !isNewOrganization) {
              <div class="form-row">
                <div class="col-12 text-warning">
                  <span translate>Do you really want to change the dataset name? You won't have access to your data!</span>
                </div>
              </div>
            }
          </div>
        </div>
        <!--DISPLAY NAME-->
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label for="description" translate>Display name</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            <input [ngClass]="{ 'is-invalid': submitted && f.description.errors }" class="form-control"
              formControlName="description"
              id="description"
              name="description"
              type="text">

              @if (submitted && f.description.errors) {
                <div class="invalid-feedback">
                  @if (f.description.errors.required) {
                    <span translate>Display name required</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="col-12 col-lg-6" [ngClass]="{'col-lg-12': isNewOrganization}">
            <!--PARENT-->
            <div class="form-group">
              <label for="parentOrganization">
                <span translate>Organization parent</span>
                <scitis-required-field-indicator></scitis-required-field-indicator>
                @if (isLoadingOrganizationParents) {
                  <span class="fa-solid fa-spinner fa-spin ml-2"></span>
                }
              </label>
              @if (!shouldHideParentDropDown()) {
                <ng-select (change)="onParentOrganizationChange($event)"
                  [items]="possibleParents"
                  [ngClass]="{ 'is-invalid': submitted && f.parentOrganization.errors }"
                  bindLabel="name"
                  bindValue="id" formControlName="parentOrganization" id="parentOrganization"
                  name="parentOrganization">
                </ng-select>
              }
              @if (shouldHideParentDropDown()) {
                <input
                  [disabled]="true"
                  class="form-control" id="parentOrganizationName"
                  name="parentOrganizationName" type="text">
              }
              @if (submitted && f.parentOrganization.errors) {
                <div class="invalid-feedback">
                  @if (f.parentOrganization.errors.required) {
                    <span translate>Parent Organization required</span>
                  }
                </div>
              }
            </div>
          </div>

          @if (!isNewOrganization) {
            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label for="externalId" translate>External id</label>
                <input [disabled]="true"
                  [readOnly]="true"
                  class="form-control"
                  formControlName="externalId"
                  id="externalId"
                  name="externalId"
                  type="text">
                </div>
              </div>
            }
          </div>

          <!--AGREEMENT-->
          <div class="form-group">
            <label for="agreement" translate>Agreement (shown on login)</label>
            <textarea class="form-control" formControlName="agreement" id="agreement" name="agreement"
            rows="6"></textarea>
          </div>

          <div class="form-row">
            <div class="col-12 col-md-6">
              <!--URL FOR USER AGREEMENT-->
              <div class="form-group">
                <label for="userAgreementUrl" translate>User agreement URL</label>
                <input [ngClass]="{ 'is-invalid': submitted && f.userAgreementUrl.errors }" class="form-control"
                  formControlName="userAgreementUrl"
                  id="userAgreementUrl"
                  name="userAgreementUrl"
                  type="url">

                  @if (submitted && f.userAgreementUrl.errors) {
                    <div class="invalid-feedback">
                      @if (f.userAgreementUrl.errors.pattern) {
                        <span translate>Invalid URL</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-12 col-md-6">
                <!--URL FOR PRIVACY POLICY URL-->
                <div class="form-group">
                  <label for="privacyPolicyUrl" translate>Privacy policy URL</label>
                  <input [ngClass]="{ 'is-invalid': submitted && f.privacyPolicyUrl.errors }" class="form-control"
                    formControlName="privacyPolicyUrl"
                    id="privacyPolicyUrl"
                    name="privacyPolicyUrl"
                    type="url">

                    @if (submitted && f.privacyPolicyUrl.errors) {
                      <div class="invalid-feedback">
                        @if (f.privacyPolicyUrl.errors.pattern) {
                          <span translate>Invalid URL</span>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>

              <!--    TABLEAU CONFIGURATION-->
              <scitis-organization-tableau-configuration
                (formIsValid)="onTableauConfigurationFormIsValid($event)"
                (updatedTableauConfigurationEvent)="onUpdatedTableauConfigurationEvent($event)"
                [tableauConfiguration]="organization.tableauConfiguration"
                >

              </scitis-organization-tableau-configuration>

            </div>

            <div class="modal-footer">
              <div class="modal-footer-inner">
                <div class="row align-items-center flex-fill">
                  <div class="col">
                    <scitis-required-field-indicator-explanation></scitis-required-field-indicator-explanation>
                  </div>
                  <div class="col-auto">
                    <button (click)="onCancel()" class="btn btn-outline-primary mr-2"
                      type="button">
                      <span translate>Cancel</span>
                    </button>
                    <button [disabled]="isDisabledSaveBtn" class="btn btn-primary" type="submit">
                      <span translate>Save</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
